import {ProductListing} from "@/components/shop/ProductListing";
import {CmsPageView} from "@/components/shop/CmsPageView";

export function ProductListPage({list, title, sort}: {list: string; title: string; sort?: number}) {
  return <ProductListing params={{list, sort}} title={title} defaultSort={sort} />;
}

export function CmsSlugPage({slug}: {slug: string}) {
  return <CmsPageView slug={slug} />;
}
